import React from 'react'
import { Field } from 'formik'
import get from 'lodash/get'
import { Radio, Select, Text, View } from 'oio-react'
import PropTypes from 'prop-types'

const ProductListItem = ({ borderStyle, onChange, product, useBatchRegistration }) => {
   const handleChange = (form, field, changeEvent) => {
      // Ensure we don't override Formik's default field onChange behaviour,
      // which is to set the field value on the form.
      form.setFieldValue(field.name, changeEvent.target.value)
      if (onChange) {
         onChange(
            product.id,
            useBatchRegistration
               ? parseInt(changeEvent.target.value, 10)
               : 1
         )
      }
   }

   const productPrice = product.price > 0
      ? product.price.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
      : 'Free'

   return (
      <View
         display="flex"
         alignItems="center"
         width="100%"
         padding="15px 0px"
         borderTop={borderStyle}>
         {!useBatchRegistration && (
            <View flex="0 0 auto" width="36px">
               <Field
                  name="product"
                  type="radio"
                  render={({ form, field }) => (
                     <Radio
                        // TODO: This line below should not be needed after Formik is upgraded to 2+
                        defaultChecked={get(form.values, 'product') === product.id}
                        {...field}
                        highlightColor="#35b865"
                        value={product.id}
                        required
                        onChange={changeEvent => handleChange(form, field, changeEvent)}
                     />
                  )}
               />
            </View>
         )}
         <View flex="1 1 auto">
            <Text size="1.5" weight="medium">
               {product.name}
            </Text>
            <Text size="1.5" color="#777">{product.description}</Text>
         </View>
         <View flex="0 0 auto" width="72px" textAlign="right">
            <Text size="1.5">
               {productPrice}
            </Text>
         </View>
         {useBatchRegistration && (
            <View
               flex="0 0 auto"
               width="50px"
               marginLeft="10px">
               <Field
                  name={`products.${product.id}`}
                  render={({ form, field }) => (
                     <Select
                        {...field}
                        onChange={changeEvent => handleChange(form, field, changeEvent)}
                        value={get(form.values, `products.${product.id}`)}>
                        <option value="0">0</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                        <option value="9">9</option>
                     </Select>
                  )}
               />
            </View>
         )}
      </View>
   )
}

ProductListItem.propTypes = {
   borderStyle: PropTypes.string,
   onChange: PropTypes.func.isRequired,
   product: PropTypes.object.isRequired
}

ProductListItem.defaultProps = {
   borderStyle: '1px solid #eee'
}

export default ProductListItem
